import { render, staticRenderFns } from "./CreateSqc.vue?vue&type=template&id=5778ca43&scoped=true&lang=true&"
import script from "./CreateSqc.vue?vue&type=script&lang=js&"
export * from "./CreateSqc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5778ca43",
  null
  
)

export default component.exports